import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

function Sidebar({ isOpen, onClose }) {
	const location = useLocation();
	const navigate = useNavigate();
	const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

	const isActive = (path) => location.pathname.startsWith(path);

	const handleLinkClick = () => {
		if (typeof onClose === 'function') onClose();
	};

	const handleLogoutClick = (e) => {
		e.preventDefault();
		if (typeof onClose === 'function') onClose();
		setIsLogoutModalOpen(true);
	};

	const closeLogoutModal = () => setIsLogoutModalOpen(false);

	const confirmLogout = () => {
		localStorage.removeItem('token');
		localStorage.removeItem('userDetail');
		closeLogoutModal();
		navigate('/login', { replace: true });
	};

	return (
	<div className={`left-bar ${isOpen ? 'sidebar-open' : ''}`} role="navigation" aria-label="Main navigation">
		<h3 className="sidebar-title">Options</h3>
		<ul>
		<li className={isActive('/admin/dashboard') ? 'active' : ''}>
			<Link to='/admin/dashboard' onClick={handleLinkClick}>
				<img src="/assets/images/sidebarDashboard.svg" alt="Dashboard" />
				Dashboard
			</Link>
		</li>
		<li className={isActive('/admin/users') ? 'active' : ''}>
			<Link to='/admin/users' onClick={handleLinkClick}>
				<img src="/assets/images/sidebarUser.svg" alt="User Management" />
				User Management
			</Link>
		</li>
		<li className={isActive('/admin/shelters') ? 'active' : ''}>
			<Link to='/admin/shelters' onClick={handleLinkClick}>
				<img src="/assets/images/sidebarShelter.svg" alt="Shelter" />
				Shelter
			</Link>
		</li>
		<li className={isActive('/admin/subscription') ? 'active' : ''}>
			<Link to='/admin/subscription' onClick={handleLinkClick}>
				<img src="/assets/images/sidebarSubscription.svg" alt="Subscription" />
				Subscription
			</Link>
		</li>
		<li className={isActive('/admin/pet-management') ? 'active' : ''}>
			<Link to='/admin/pet-management' onClick={handleLinkClick}>
				<img src="/assets/images/sidebarPets.svg" alt="Pet management" />
				Pet management
			</Link>
		</li>
		<li className={isActive('/admin/settings') ? 'active' : ''}>
			<Link to='/admin/settings' onClick={handleLinkClick}>
				<img src="/assets/images/sidebarSettings.svg" alt="Setting" />
				Setting
			</Link>
		</li>
		</ul>
		<div className="sidebar-footer">
			<button type="button" className="logout-link" onClick={handleLogoutClick}>
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '10px'}}>
					<path d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
				Logout
			</button>
		</div>

		<Modal
			isOpen={isLogoutModalOpen}
			onRequestClose={closeLogoutModal}
			contentLabel="Logout"
			className="logout-modal"
			overlayClassName="add-shelter-overlay"
			ariaHideApp={false}
		>
			<div className="logout-modal-content">
				<h2 className="logout-modal-title">Logout</h2>
				<p className="logout-modal-message">Are you sure you want to logout?</p>
				<div className="logout-modal-actions">
					<button type="button" className="logout-modal-confirm-btn" onClick={confirmLogout}>
						Logout
					</button>
				</div>
			</div>
		</Modal>
	</div>
	);
}

export default Sidebar